<template>
  <div class="order-now">
    <div class="card-view-wrap">
      <div class="container">
        <h3>Order Now!</h3>
        <div class="cards">
          <CardView
            :restaurant="restaurant"
            v-for="(restaurant, index) in sampleRestaurantsData"
            :key="index"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardView from "../components/CardView";
//import RestaurantModal from "../components/RestaurantModal";

export default {
  name: "OrderNowStatic",
  components: {
    CardView,
  },
  data() {
    return {
      // The link would basically loop through the data and show the menu in the desired format
      sampleRestaurantsData: [
        {
          name: "Mala HotPot",
          location: "PGP-AC Canteen",
          photo: "MalaHotpot",
          link:
            "Link to Page showing their menu, basically name of the restaurant i guess",
          menuDis: "Maybe an array with key value pairs such as item, price",
          tags: ["Chinese", "Asian", "Noodles", "Mala", "Hotpot"],
        },
        {
          name: "Dickson's Nan House",
          location: "PGP-AC Canteen",
          photo: "Dickson",
          link: "Link to Page showing their menu",
          menuDis: "Maybe an array with key value pairs such as item, price",
          menu: [
            {
              itemName: "Nan",
              itemPrice: 1.0,
            },
            {
              itemName: "Cheese Nan",
              itemPrice: 2.0,
            },
            {
              itemName: "Butter Nan",
              itemPrice: 1.5,
            },
            {
              itemName: "Garlic Nan",
              itemPrice: 1.5,
            },
            {
              itemName: "Garlic Butter Nan",
              itemPrice: 2.0,
            },
          ],
          tags: ["Indian", "Asian", "Nan", "Chicken", "Paneer", "Vegetarian"],
        },
        {
          name: "Korean Food",
          location: "PGP-AC Canteen",
          photo: "Korean",
          link: "Link to Page showing their menu",
          menu: "Maybe an array with key value pairs such as item, price",
          tags: ["Korean", "Asian", "Noodles", "Chicken", "Wrap"],
        },
        {
          name: "Thai Food",
          location: "Fine Food, UTown",
          photo: "Thai",
          link: "Link to Page showing their menu",
          menu: "Maybe an array with key value pairs such as item, price",
          tags: ["Thai", "Asian", "Noodles", "Chicken", "Wrap"],
        },
        {
          name: "Fish Soup",
          location: "PGP-AC Canteen",
          photo: "FishSoup",
          link: "Link to Page showing their menu",
          menu: "Maybe an array with key value pairs such as item, price",
          tags: ["Fish", "Asian", "Soup", "Chicken"],
        },
        {
          name: "Pasta Express",
          location: "The Deck",
          photo: "TheDeck",
          link: "Link to Page showing their menu",
          menu: "Maybe an array with key value pairs such as item, price",
          tags: ["Pasta", "Western", "Tomato", "Chicken", "Vegetarian"],
        },
        {
          name: "Indian Food",
          location: "Engineering Canteen",
          photo: "Dickson",
          link: "Link to Page showing their menu",
          menu: "Maybe an array with key value pairs such as item, price",
          tags: ["Indian", "Asian", "Nan", "Chicken", "Paneer", "Vegetarian"],
        },
        {
          name: "Trio Tea",
          location: "PGP-AC Canteen",
          photo: "BubbleTea",
          link: "Link to Page showing their menu",
          menu: "Maybe an array with key value pairs such as item, price",
          tags: ["Tea", "Asian", "Bubble", "Pearls", "Sweet", "Milk"],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.order-now {
  p {
    margin-top: 20px;
    text-align: center;
    font-size: 40px;
  }
}

.card-view-wrap {
  h3 {
    font-weight: 300;
    font-size: 28px;
    margin-bottom: 32px;
  }
}
</style>
